<template>
  <v-card
    :disabled="getLoading"
    :loading="getLoading && loadingAllowed"
    class="rounded-lg"
  >
    <template #loader>
      <v-progress-linear
        :color="getLoadingColor"
        height="3.5"
        v-if="getLoading && loadingAllowed"
        indeterminate
      />
    </template>

    <v-card-title v-if="title">
      <v-icon
        v-if="icon"
        class="me-1 pr-2"
        size="small"
      >
        {{ icon }}
      </v-icon>

      <span style="font-size: 18px">{{ title }}</span>
    </v-card-title>
    <v-divider v-if="title" />
    <v-card-text :class="vCardTextClass">
      <slot />
    </v-card-text>
    <template v-if="$slots.actions">
      <v-divider />
      <v-card-actions>
        <slot name="actions" />
      </v-card-actions>
    </template>
  </v-card>
</template>

<script>
export default {
  name: "BaseCard",

  props: {
    title: {
      type: String,
      default: "",
    },

    icon: {
      type: String,
      default: "",
    },
    loading: {
      type: Boolean,
      default: false,
    },
    loadingAllowed: {
      type: Boolean,
      default: true,
    },
    vCardTextClass: {
      type: String,
      default: "pa-0",
    }
  },

  computed: {
    getLoading() {
      return this.$store.getters.getLoading;
    },
    getLoadingColor() {
      return this.$store.getters.getLoadingColor;
    }
  },
};
</script>